import { z } from 'zod';
export const verificationTimingSchema = z.object({
    expiresAt: z.string(),
    resendAvailableAt: z.string(),
});
export const tokenRefreshSchema = z.object({
    accessToken: z.string(),
    accessTokenExpiresAt: z.string(),
    familyId: z.string(),
});
export const termAcceptanceSchema = z.object({
    termDocumentId: z.string(),
    agreed: z.boolean(),
});
export const publishedTermSchema = z.object({
    id: z.string(),
    type: z.string(),
    version: z.number(),
    title: z.string(),
    summary: z.string(),
    required: z.boolean(),
    effectiveAt: z.string(),
    publishedAt: z.string(),
});
export const termVersionSchema = z.object({
    id: z.string(),
    version: z.number(),
    title: z.string(),
    effectiveAt: z.string(),
    publishedAt: z.string(),
});
export const termDocumentDetailSchema = publishedTermSchema.extend({
    body: z.string(),
    requiresReconsent: z.boolean(),
});
/** Azure Web PubSub negotiate 응답 — 클라이언트가 그대로 `WebPubSubClient`에 넘길 Client Access URL. */
export const realtimeNegotiateSchema = z.object({
    url: z.string(),
});
/**
 * 클라이언트가 서버 enc 공개키(JWKS `use: enc`)로 봉인해 올리는 값.
 * 와이어 형태는 JWE Compact Serialization 하나로 고정한다 — `alg: 'RSA-OAEP-256'`(CEK를
 * Key Vault `unwrapKey`로 언랩) + `enc: 'A256GCM'`(본문은 그 CEK로 서버가 AES-GCM 복호).
 * 서버 복호는 `@lunacast/api-crypto`의 `unsealSecretValue()`가 맡는다.
 */
export const secretValueSchema = z
    .string()
    .regex(/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/, 'SecretValue는 JWE Compact(5-part) 문자열이어야 한다.');
/** SecretValue 복호가 폐기·로테이션된 키를 만났을 때의 비즈니스 오류 코드. 클라이언트는 JWKS를 강제 재조회한 뒤 재봉인·1회 재시도한다. */
export const STALE_ENCRYPTION_KEY_CODE = 'STALE_ENCRYPTION_KEY';
//# sourceMappingURL=schemas.js.map